import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import bem from '../../../lib/bemUtils/bem';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import { TextMarker } from '../../../_lib/components/TextMarker/TextMarker';

export enum TextSnippetModifier {
  COLLAPSIBLE = 'collapsible',
}

export function TextSnippet({ text, modifier }: { text: string; modifier?: Modifier<TextSnippetModifier> }) {
  const { t } = useSonTranslation('SearchResultTeaser');
  // replace all '...' by &hellip;
  const content = text.replaceAll('...', '\u2026');

  return (
    <p className={bem('search-result-teaser__text', modifier)}>
      <dfn className="invisible">{t('textSnippet')}: </dfn>
      <TextMarker text={content} />
    </p>
  );
}
